module.exports = __webpack_public_path__ + "static/media/D.590bcafc.jpg";